

















import Vue from 'vue'

import LetterDisplay from '@/components/letters/Display.vue'
import Activity from '@/views/treatment/depression/cbt/activities-diary/Activity.vue'
import Reframing from '@/views/treatment/depression/cbt/reframings-diary/Reframing.vue'
import Thought from '@/views/treatment/depression/cbt/thoughts-diary/Thought.vue'
import Conflict from '@/views/treatment/depression/ipt/conflicts-diary/Conflict.vue'
import Relationship from '@/views/treatment/depression/ipt/relationships-diary/Relationship.vue'
import Situation from '@/views/treatment/depression/ipt/strategies-diary/Situation.vue'
import SituationVue from '@/views/treatment/depression/ipt/strategies-diary/Situation.vue'

export default Vue.extend({
  components: {
    Activity,
    Reframing,
    Thought,
    Conflict,
    Relationship,
    Situation,
    LetterDisplay,
  },
  methods: {
    chooseEditorFor(exercise: {
      type:
        | 'letter'
        | 'conflict'
        | 'relationship'
        | 'situation'
        | 'activity'
        | 'reframing'
        | 'thought'
    }) {
      switch (exercise.type) {
        case 'letter':
          return LetterDisplay
        case 'conflict':
          return Conflict
        case 'relationship':
          return Relationship
        case 'situation':
          return Situation
        case 'activity':
          return Activity
        case 'reframing':
          return Reframing
        case 'thought':
          return Thought
        default:
          throw new Error(`unknown exercise type ${(exercise as any).type}`)
      }
    },
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    noLoad: {
      type: Boolean,
      default: false,
    },
  },
})
